/**
 * @Name 订单列表路由配置区
*/
import orderConfig from '@/views/my_order/index.vue'

export default [
    {
        path: 'orderConfig',
        name: 'orderConfig',
        component: orderConfig,
        children: [
            { // 个人信息
                path: 'personalInfo',
                name: 'personalInfo',
                component: () => import('@/views/personal_center/index.vue'),
                meta: { prem: 'NOTTOURISTS' }
            },
            { // 常用联系人
                path: 'commonContacts',
                name: 'commonContacts',
                component: () => import('@/views/personal_center/CommonContacts.vue'),
                meta: { prem: 'NOTTOURISTS' }
            },
            { // 常用地址
                path: 'commonAddress',
                name: 'commonAddress',
                component: () => import('@/views/personal_center/CommonAddress.vue'),
                meta: { prem: 'NOTTOURISTS' }
            },
            { // 常用发票
                path: 'commonInvoice',
                name: 'commonInvoice',
                component: () => import('@/views/personal_center/CommonInvoice.vue'),
                meta: { prem: 'NOTTOURISTS' }
            },
            { // 我的导入导出
                path: 'myImportExport',
                name: 'myImportExport',
                component: () => import('@/views/personal_center/my_import_export/index.vue'),
                meta: { prem: 'NOTTOURISTS' }
            }
        ]
    }
]
